module.exports = __webpack_public_path__ + "img/varilux-s-series.63aaa6fc.svg";